import React from 'react';
import DayPicker from 'react-day-picker';
import classNameBind from 'classnames/bind';
import moment from 'moment';
import 'react-day-picker/lib/style.css';

import defaultClassNames from './defaultClassNames';
import styles from './styles.module.css';
import Navbar from './NavBar';
import getDateInAllowedRange from '../../methods/getDateInAllowedRange';
import getDate from '../../methods/getDate';
import CaptionElement from '../CaptionElement';

const bindClasses = classNameBind.bind(styles);

const classNames = Object.entries(defaultClassNames).reduce(
  (accumulator, [label, classes]) => ({ ...accumulator, [label]: bindClasses(classes.split(' ')) }),
  {},
);

const disabledClass = classNames.disabled;

class CalendarDatePicker extends React.Component {
  static isDayEnabled(modifiers) {
    return !modifiers[disabledClass];
  }

  constructor(props) {
    super(props);
    this.state = {
    };
  }

  static getDerivedStateFromProps(props, state) {
    const {
      selectedDate,
      min,
      max,
    } = props;

    let firstCalendarMonth = getDate(
      getDateInAllowedRange(selectedDate, min, max),
    );
    const {
      firstCalendarMonth: previousFirstCalendarMonth,
      oldFirstCalendarMonth,
    } = state;

    if (previousFirstCalendarMonth !== oldFirstCalendarMonth && typeof oldFirstCalendarMonth !== 'undefined') {
      firstCalendarMonth = previousFirstCalendarMonth;
    }

    return {
      firstCalendarMonth,
    };
  }

  handleDayClick = (day, modifiers) => {
    if (CalendarDatePicker.isDayEnabled(modifiers)) {
      this.handleChange(day);
    }
  };

  handleChange = (selected) => {
    this.props.onChange(moment(selected));
  };

  render() {
    const {
      firstDayOfWeek,
      selectedDate: rawSelectedDate,
      min: rawMin,
      max: rawMax,
      reportDatePickerLikeYearsRange,
    } = this.props;
    const min = getDate(rawMin);
    const max = getDate(rawMax);
    const selectedDate = getDate(rawSelectedDate);
    const {
      firstCalendarMonth,
    } = this.state;
    const disabledDays = {
      after: max,
      before: min,
    };

    const selectedDays = [selectedDate];

    const modifiers = {
      [bindClasses('DayPicker-Day--start')]: true,
    };

    const sharedProps = {
      classNames,
      selectedDays,
      disabledDays,
      modifiers,
      firstDayOfWeek,
      navbarElement: Navbar,
      showOutsideDays: true,
      enableOutsideDaysClick: false,
      onDayClick: this.handleDayClick,
    };

    return (
      <div className={bindClasses('wrapper')} data-ppuc-id="DatePicker.CalendarRangePicker">
        <DayPicker
          {...sharedProps}
          fromMonth={min}
          toMonth={max}
          onMonthChange={(month) => {
            this.setState({ firstCalendarMonth: month, oldFirstCalendarMonth: firstCalendarMonth });
          }}
          month={firstCalendarMonth}
          captionElement={date => (
            <CaptionElement
              date={date.date}
              onChange={
                (modifiedDate) => {
                  this.setState({
                    firstCalendarMonth: modifiedDate,
                    oldFirstCalendarMonth: firstCalendarMonth,
                  });
                }}
              min={min}
              max={max}
              reportDatePickerLikeYearsRange={reportDatePickerLikeYearsRange}
            />
          )}
        />
      </div>
    );
  }
}

CalendarDatePicker.defaultProps = {
  selectedDate: null,
  min: null,
  max: null,
};

export default CalendarDatePicker;
